import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { reportCorporateShipmentsTypes } from "redux/reducers/Reports/reportCorporateShipments/types";

const { SET_REPORT_CORPORATE_SHIPMENTS_FILTERS } = reportCorporateShipmentsTypes;

export const getReportCorporateShipmentsAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/shipments_enersi/report/pdf?start=${startDate}&end=${endDate}&idStation=${station.id}&pdf=${isPdf}`;
    const fileName = `Reporte_embarques_corporativo_${station.name}_${startDate}_${endDate}.${isPdf ? `pdf` : `xlsx`}`;

    dispatch(startRequestComp('loadingReportCorporateShipments'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth,
    };
    try {
      const pdf = await axios(access);
      saveAs(pdf.data, fileName);
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportCorporateShipments'));
    }
  };
};

export const setReportCorporateShipmentsFilters = (key = "", value) => {
  return {
    type: SET_REPORT_CORPORATE_SHIPMENTS_FILTERS,
    payload: { value, key },
  };
};
